'use client'
import React from 'react'

import GladlyHelpCenter from './contact-us-components/glady-help-center/glady-help-center'
import OrdersAndReturnsSection from './contact-us-components/orders-and-returns-section/orders-return'
import Support from './contact-us-components/support-section/support-section'
import styles from './contact-us.module.scss'
import { SectionType } from './contact-us.types'

interface Props {
  data: {
    landingPage: {
      sections: SectionType[]
    }
  }
}

const ContactUsPage: React.FC<Props> = ({ data: { landingPage: { sections = [] } = {} } = {} }) => {
  const textSections = sections.filter(section => section.__typename === 'ContentfulTextSection').slice(-4)
  const svgSections = sections.filter(section => section.__typename === 'ContentfulSvgWithText').slice(-3)
  const bannerData = sections.filter(section => section.__typename === 'ContentfulBanner')[1]

  const disclaimerText = textSections.pop()
  return (
    <div className={styles.contactUsWrapper}>
      <OrdersAndReturnsSection sections={svgSections} bannerData={bannerData} />
      <GladlyHelpCenter />
      <Support disclaimerText={disclaimerText} sections={textSections} bannerData={bannerData} />
    </div>
  )
}

export default ContactUsPage
